import { SessionService } from '@/users/application/Session/SessionService';
import AnalyticsTrackRepository from '@/finsight/infrastructure/repository/AnalyticsTrackRepository';
import { useDIContext } from '@/Framework/DI/DIContext';
import { moduleMapper } from '@/finsight/application/constants';

export const useTrackAnalytics = () => {
  const { container } = useDIContext();
  const sessionService = container.get(SessionService);

  const trackAnalytics = async ({ module }) => {
    const contactId = sessionService?.currentUser?.id;

    if (contactId) {
      const { trackKey } = moduleMapper[module];
      const analyticsTrackRepository = container.get(AnalyticsTrackRepository);

      analyticsTrackRepository.track(
        trackKey,
        {
          ...(contactId && { contactId }),
        },
      );
    }
  };

  return {
    trackAnalytics,
  };
};
